// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messagingButton {
    width: 10rem;
    background-color: #3fc56e;
    color: white;
    padding: 15px 30px;
    border-radius: 5px;
    outline: 0;
    border: 0; 
    margin: 10px 0px;
    cursor: pointer;
    box-shadow: 0px 2px 2px lightgray;
    transition: ease background-color 250ms;
    font-weight: bold;
    position: relative;
    align-self: center;
    top: 150px;
}

.messagingButton:hover:not(:disabled) {
    background-color: #2d8645;
}

.messagingButton:disabled {
    cursor: not-allowed;
    opacity: 0.7;
}

/**
 * Styles related to the spinner shown on Messaging Button
 */
.messagingButtonLoadingUI {
    --color: white;
    --size-mid: 4vmin;
    --size-dot: 1.5vmin;
    --size-bar: 0.4vmin;
    --size-square: 3vmin;
    position: relative;
    width: 50%;
    display: block;
    bottom: 30px;
}

.messagingButtonLoadingUI::before,
.messagingButtonLoadingUI::after {
	content: '';
	box-sizing: border-box;
	position: absolute;
}

.messagingButtonLoadingUI.loadingBalls::before {
	width: var(--size-mid);
	height: var(--size-mid);
	border: 4px solid white;
	border-top-color: transparent;
	border-radius: 50%;
	animation: loadingAnimation 1s linear infinite;
}

.messagingButtonLoadingUI.loadingBalls::after {
	width: calc(var(--size-mid) - 2px);
	height: calc(var(--size-mid) - 2px);
	border: 2px solid transparent;
	border-top-color: white;
	border-radius: 50%;
	animation: loadingAnimation 0.6s linear reverse infinite;
}

.messagingInputTextarea {
    border-width: 0px;
    outline: none;
}
.inputdiv {
    border-radius: 5px;
    border-color: gray;
    border-width: 2px;
    border-style: solid;
    padding: 0px 10px 0px 10px;
}

@keyframes loadingAnimation {
	100% {
		transform: rotate(1turn);
	}
}

.centerclass {
    position: fixed;
    top: calc(50% - 75px);
    left: calc(50% - 75px);
}`, "",{"version":3,"sources":["webpack://./src/components/messagingButton.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,iCAAiC;IACjC,uCAAuC;IACvC,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;EAEE;AACF;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,YAAY;AAChB;;AAEA;;CAEC,WAAW;CACX,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,uBAAuB;CACvB,6BAA6B;CAC7B,kBAAkB;CAClB,8CAA8C;AAC/C;;AAEA;CACC,kCAAkC;CAClC,mCAAmC;CACnC,6BAA6B;CAC7B,uBAAuB;CACvB,kBAAkB;CAClB,wDAAwD;AACzD;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,sBAAsB;AAC1B","sourcesContent":[".messagingButton {\n    width: 10rem;\n    background-color: #3fc56e;\n    color: white;\n    padding: 15px 30px;\n    border-radius: 5px;\n    outline: 0;\n    border: 0; \n    margin: 10px 0px;\n    cursor: pointer;\n    box-shadow: 0px 2px 2px lightgray;\n    transition: ease background-color 250ms;\n    font-weight: bold;\n    position: relative;\n    align-self: center;\n    top: 150px;\n}\n\n.messagingButton:hover:not(:disabled) {\n    background-color: #2d8645;\n}\n\n.messagingButton:disabled {\n    cursor: not-allowed;\n    opacity: 0.7;\n}\n\n/**\n * Styles related to the spinner shown on Messaging Button\n */\n.messagingButtonLoadingUI {\n    --color: white;\n    --size-mid: 4vmin;\n    --size-dot: 1.5vmin;\n    --size-bar: 0.4vmin;\n    --size-square: 3vmin;\n    position: relative;\n    width: 50%;\n    display: block;\n    bottom: 30px;\n}\n\n.messagingButtonLoadingUI::before,\n.messagingButtonLoadingUI::after {\n\tcontent: '';\n\tbox-sizing: border-box;\n\tposition: absolute;\n}\n\n.messagingButtonLoadingUI.loadingBalls::before {\n\twidth: var(--size-mid);\n\theight: var(--size-mid);\n\tborder: 4px solid white;\n\tborder-top-color: transparent;\n\tborder-radius: 50%;\n\tanimation: loadingAnimation 1s linear infinite;\n}\n\n.messagingButtonLoadingUI.loadingBalls::after {\n\twidth: calc(var(--size-mid) - 2px);\n\theight: calc(var(--size-mid) - 2px);\n\tborder: 2px solid transparent;\n\tborder-top-color: white;\n\tborder-radius: 50%;\n\tanimation: loadingAnimation 0.6s linear reverse infinite;\n}\n\n.messagingInputTextarea {\n    border-width: 0px;\n    outline: none;\n}\n.inputdiv {\n    border-radius: 5px;\n    border-color: gray;\n    border-width: 2px;\n    border-style: solid;\n    padding: 0px 10px 0px 10px;\n}\n\n@keyframes loadingAnimation {\n\t100% {\n\t\ttransform: rotate(1turn);\n\t}\n}\n\n.centerclass {\n    position: fixed;\n    top: calc(50% - 75px);\n    left: calc(50% - 75px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
